import React from 'react';
import { Field } from 'formik';
import { Checkbox } from 'components/Form/SpecialButtons';
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

const OtherForm = () => (
	<div>
		<Field
			id='disableFolderSecondValidation'
			name='disableFolderSecondValidation'
			customlabel='Désactiver la seconde phase de validation et générer le JSON de GesLab lors de la validation préleveuse'
			component={Checkbox}
			required
		/>
		<Field type="text" name="companyShortcuts" customlabel="Raccourcis sociétés (séparés par des ';')" component={CustomInputTextComponent}/> 
		  <Field type="number" name="urgencyPretreatementLimit" customlabel="Limite max du temps en minutes pour afficher un timer sur le tube" component={CustomInputTextComponent}/>
	</div>
);

export default OtherForm;
